import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import LoggerFactory from 'live/services/logger'
import serviceLocator from 'live/services/service-locator'

import { IUpdateModeFrontPresenter, UpdateModeFrontAPI } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'
import { IBarrier } from 'plugin-codaf-risk-ext-bowtie/types'

import { enUS, ptBR } from './i18n'
import { QuantitativeLiveApi } from './updateMode/QuantitativeLiveApi'

export const logger = LoggerFactory('plugin-quantitative-live-event-dra-engine')

const locales = { pt_br: ptBR, en_us: enUS }
i18n.add(locales[locale ?? 'en_us'])

type ILiveApiBarrierConfig = {
    systemId: string
}

function requestValidationArray(barrier: IBarrier): string[] {
    const errorsArray: string[] = []

    const systemId = (barrier.updateModeJsonConfig as ILiveApiBarrierConfig)?.systemId

    if (!systemId || systemId === '') {
        errorsArray.push(i18n('LIVE event ID'))
    }

    return errorsArray
}

const quantitativeLiveApiPresenter: IUpdateModeFrontPresenter = {
    label: 'Quantitative LIVE Event',
    method: 'QUANTITATIVE',
    component: QuantitativeLiveApi,
    updateModeCode: 'quantitative_live_event',
    validationFunction: requestValidationArray
}

serviceLocator.getService('dra:updatemodefrontservice').then((updateModeFrontAPI: unknown) => {
    try {
        ;(updateModeFrontAPI as UpdateModeFrontAPI).addUpdateModeFrontPresenter(quantitativeLiveApiPresenter)
        logger.info('front sucesseful registered to DRA engines')
    } catch (e) {
        logger.error(e)
    }
})
